//import './swiper-works';
import './burger-menu';
import './map/gmap';
import './aos';
import './language-switcher';
import './animations';

import "wicg-inert";
